export const data = [
  {
    name: "The Shawshank Redemption",
    img: "https://upload.wikimedia.org/wikipedia/en/8/81/ShawshankRedemptionMoviePoster.jpg",
    statistics: [
      "1994",
      "9.3 IMDb",
      "143 minutes",
      "Drama"
    ],
  },
  {
    name: "The Godfather",
    img: "https://upload.wikimedia.org/wikipedia/en/1/1c/Godfather_ver1.jpg",
    statistics: [
      "1972",
      "9.2 IMDb",
      "175 minutes",
      "Crime, Drama"
    ],
  },
  {
    name: "The Dark Knight",
    img: "https://m.media-amazon.com/images/M/MV5BMTMxNTMwODM0NF5BMl5BanBnXkFtZTcwODAyMTk2Mw@@._V1_.jpg",
    statistics: [
      "2008",
      "9.0 IMDb",
      "152 minutes",
      "Action, Crime, Drama"
    ],
  },
  {
    name: "The Godfather Part II",
    img: "https://upload.wikimedia.org/wikipedia/en/0/03/Godfather_part_ii.jpg",
    statistics: [
      "1974",
      "9.0 IMDb",
      "202 minutes",
      "Crime, Drama"
    ],
  },
  {
    name: "12 Angry Men",
    img: "https://m.media-amazon.com/images/M/MV5BNDhjMjE4NDItZTkyOC00NjIwLWI0MDQtYTJhZjY2YzlkMDQ0XkEyXkFqcGdeQXVyMTA0MTM5NjI2._V1_.jpg",
    statistics: [
      "1957",
      "9.0 IMDb",
      "96 minutes",
      "Drama"
    ],
  },
  {
    name: "Schindler's List",
    img: "https://upload.wikimedia.org/wikipedia/en/3/38/Schindler%27s_List_movie.jpg",
    statistics: [
      "1993",
      "9.0 IMDb",
      "195 minutes",
      "Biography, Drama, History"
    ],
  },
  {
    name: "The Lord of the Rings: The Return of the King",
    img: "https://m.media-amazon.com/images/M/MV5BNzA5ZDNlZWMtM2NhNS00NDJjLTk4NDItYTRmY2EwMWZlMTY3XkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_FMjpg_UX1000_.jpg",
    statistics: [
      "2003",
      "9.0 IMDb",
      "201 minutes",
      "Action, Adventure, Drama"
    ],
  },
  {
    name: "Pulp Fiction",
    img: "https://m.media-amazon.com/images/M/MV5BNGNhMDIzZTUtNTBlZi00MTRlLWFjM2ItYzViMjE3YzI5MjljXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg",
    statistics: [
      "1994",
      "8.9 IMDb",
      "154 minutes",
      "Crime, Drama"
    ],
  },
  {
    name: "The Good, the Bad and the Ugly",
    img: "https://upload.wikimedia.org/wikipedia/en/4/45/Good_the_bad_and_the_ugly_poster.jpg",
    statistics: [
      "1966",
      "8.8 IMDb",
      "178 minutes",
      "Western"
    ],
  },
  {
    name: "Fight Club",
    img: "https://upload.wikimedia.org/wikipedia/en/f/fc/Fight_Club_poster.jpg",
    statistics: [
      "1999",
      "8.8 IMDb",
      "139 minutes",
      "Drama"
    ],
  },
  {
    name: "Forrest Gump",
    img: "https://upload.wikimedia.org/wikipedia/en/6/67/Forrest_Gump_poster.jpg",
    statistics: [
      "1994",
      "8.8 IMDb",
      "142 minutes",
      "Drama, Romance"
    ],
  },
  {
    name: "Inception",
    img: "https://m.media-amazon.com/images/M/MV5BMjAxMzY3NjcxNF5BMl5BanBnXkFtZTcwNTI5OTM0Mw@@._V1_.jpg",
    statistics: [
      "2010",
      "8.8 IMDb",
      "148 minutes",
      "Action, Adventure, Sci-Fi"
    ],
  },
  {
    name: "The Lord of the Rings: The Fellowship of the Ring",
    img: "https://m.media-amazon.com/images/M/MV5BN2EyZjM3NzUtNWUzMi00MTgxLWI0NTctMzY4M2VlOTdjZWRiXkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_FMjpg_UX1000_.jpg",
    statistics: [
      "2001",
      "8.8 IMDb",
      "178 minutes",
      "Action, Adventure, Drama"
    ],
  },
  {
    name: "Star Wars: Episode V - The Empire Strikes Back",
    img: "https://m.media-amazon.com/images/M/MV5BYmU1NDRjNDgtMzhiMi00NjZmLTg5NGItZDNiZjU5NTU4OTE0XkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg",
    statistics: [
      "1980",
      "8.7 IMDb",
      "124 minutes",
      "Action, Adventure, Fantasy"
    ],
  },
  {
    name: "The Matrix",
    img: "https://upload.wikimedia.org/wikipedia/en/c/c1/The_Matrix_Poster.jpg",
    statistics: [
      "1999",
      "8.7 IMDb",
      "136 minutes",
      "Action, Sci-Fi"
    ],
  },
  {
    name: "Goodfellas",
    img: "https://m.media-amazon.com/images/M/MV5BY2NkZjEzMDgtN2RjYy00YzM1LWI4ZmQtMjIwYjFjNmI3ZGEwXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg",
    statistics: [
      "1990",
      "8.7 IMDb",
      "146 minutes",
      "Biography, Crime, Drama"
    ],
  },
  {
    name: "One Flew Over the Cuckoo's Nest",
    img: "https://m.media-amazon.com/images/M/MV5BZjA0OWVhOTAtYWQxNi00YzNhLWI4ZjYtNjFjZTEyYjJlNDVlL2ltYWdlL2ltYWdlXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_FMjpg_UX1000_.jpg",
    statistics: [
      "1975",
      "8.7 IMDb",
      "133 minutes",
      "Drama"
    ],
  },
  {
    name: "Se7en",
    img: "https://upload.wikimedia.org/wikipedia/en/6/68/Seven_%28movie%29_poster.jpg",
    statistics: [
      "1995",
      "8.6 IMDb",
      "127 minutes",
      "Crime, Drama, Mystery"
    ],
  },
  {
    name: "The Silence of the Lambs",
    img: "https://upload.wikimedia.org/wikipedia/en/8/86/The_Silence_of_the_Lambs_poster.jpg",
    statistics: [
      "1991",
      "8.6 IMDb",
      "118 minutes",
      "Crime, Drama, Thriller"
    ],
  },
  {
    name: "It's a Wonderful Life",
    img: "https://upload.wikimedia.org/wikipedia/commons/2/25/It%27s_a_Wonderful_Life_%281946_poster%29.jpeg",
    statistics: [
      "1946",
      "8.6 IMDb",
      "130 minutes",
      "Drama, Family, Fantasy"
    ],
  },
  {
    name: "Life Is Beautiful",
    img: "https://upload.wikimedia.org/wikipedia/en/7/7c/Vitaebella.jpg",
    statistics: [
      "1997",
      "8.6 IMDb",
      "116 minutes",
      "Comedy, Drama, Romance"
    ],
  },
  {
    name: "The Usual Suspects",
    img: "https://upload.wikimedia.org/wikipedia/en/9/9c/Usual_suspects_ver1.jpg",
    statistics: [
      "1995",
      "8.5 IMDb",
      "106 minutes",
      "Crime, Drama, Mystery"
    ],
  },
  {
    name: "Léon: The Professional",
    img: "https://upload.wikimedia.org/wikipedia/en/0/03/Leon-poster.jpg",
    statistics: [
      "1994",
      "8.5 IMDb",
      "110 minutes",
      "Action, Crime, Drama"
    ],
  },
  {
    name: "Spirited Away",
    img: "https://upload.wikimedia.org/wikipedia/en/d/db/Spirited_Away_Japanese_poster.png",
    statistics: [
      "2001",
      "8.5 IMDb",
      "125 minutes",
      "Animation, Adventure, Family"
    ],
  },
  {
    name: "Saving Private Ryan",
    img: "https://upload.wikimedia.org/wikipedia/en/a/ac/Saving_Private_Ryan_poster.jpg",
    statistics: [
      "1998",
      "8.6 IMDb",
      "169 minutes",
      "Drama, War"
    ],
  },
  {
    name: "City of God",
    img: "https://upload.wikimedia.org/wikipedia/en/1/10/CidadedeDeus.jpg",
    statistics: [
      "2002",
      "8.6 IMDb",
      "130 minutes",
      "Crime, Drama"
    ],
  },
  {
    name: "Interstellar",
    img: "https://upload.wikimedia.org/wikipedia/en/b/bc/Interstellar_film_poster.jpg",
    statistics: [
      "2014",
      "8.6 IMDb",
      "169 minutes",
      "Adventure, Drama, Sci-Fi"
    ],
  },
]
  